import React from 'react';
import { Image } from '@design-manager-inc/ui';

interface ILogoProps {
	src: string;
	alt: string;
	imageError: boolean;
	onError: () => void;
	onClick: () => void;
}

export const Logo = ({
	src,
	alt,
	imageError,
	onError,
	onClick,
}: ILogoProps) => (
	<button
		type="button"
		className="size-[80px] cursor-pointer"
		onClick={onClick}
	>
		{imageError ? (
			<div className="size-[80px]" />
		) : (
			<Image src={src} alt={alt} onError={onError} />
		)}
	</button>
);
